import Layout from '@/layout';
var kemaiRouter = {
  path: '/kemai',
  component: Layout,
  redirect: '/kemai/config',
  name: 'Kemai',
  meta: {
    title: '科脉管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'config',
    name: 'KemaiConfig',
    component: function component() {
      return import('@/views/pet/kemai/config');
    },
    meta: {
      title: '科脉配置',
      icon: ''
    }
  }, {
    path: 'message',
    name: 'KemaiMessage',
    component: function component() {
      return import('@/views/pet/kemai/message');
    },
    meta: {
      title: '科脉消息',
      icon: ''
    }
  }, {
    path: 'payment-session',
    name: 'KemaiPaymentSession',
    component: function component() {
      return import('@/views/pet/kemai/paymentSession');
    },
    meta: {
      title: '组合支付同步',
      icon: ''
    }
  }, {
    path: 'settlement-sync',
    name: 'KemaiSettlementSync',
    component: function component() {
      return import('@/views/pet/kemai/settlementSync');
    },
    meta: {
      title: '结算同步状态',
      icon: ''
    }
  }, {
    path: 'log',
    name: 'KemaiLog',
    component: function component() {
      return import('@/views/pet/kemai/log');
    },
    meta: {
      title: '接口日志',
      icon: ''
    }
  }, {
    path: 'query',
    name: 'KemaiQuery',
    component: function component() {
      return import('@/views/pet/kemai/query');
    },
    meta: {
      title: 'ID查询',
      icon: ''
    }
  }, {
    path: 'binding',
    name: 'KemaiBinding',
    component: function component() {
      return import('@/views/pet/kemai/binding');
    },
    meta: {
      title: '门店仓库绑定',
      icon: ''
    }
  }, {
    path: 'store-sync',
    name: 'KemaiStoreSync',
    component: function component() {
      return import('@/views/pet/kemai/storeSync');
    },
    meta: {
      title: '门店仓库同步',
      icon: ''
    }
  }, {
    path: 'mapping',
    name: 'KemaiMapping',
    component: function component() {
      return import('@/views/pet/kemai/mapping');
    },
    meta: {
      title: '编码映射',
      icon: ''
    }
  }, {
    path: 'stock',
    name: 'KemaiStock',
    component: function component() {
      return import('@/views/pet/kemai/stock');
    },
    meta: {
      title: '库存展示配置',
      icon: ''
    }
  }, {
    path: 'region-rule',
    name: 'KemaiRegionRule',
    component: function component() {
      return import('@/views/pet/kemai/regionRule');
    },
    meta: {
      title: '配送自取规则',
      icon: ''
    }
  }]
};
export default kemaiRouter;